import React from "react";

// A reusable shimmering skeleton preview approximating a form layout
export const SkeletonPreview: React.FC = () => {
  return (
    <div className="h-full overflow-y-auto bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 py-6 animate-pulse">
        {/* Title */}
        <div className="h-6 w-64 bg-gray-200 rounded mb-6" />

        {/* Progress bar placeholder */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <div className="h-3 w-20 bg-gray-200 rounded" />
            <div className="h-3 w-12 bg-gray-200 rounded" />
          </div>
          <div className="h-2 w-full bg-gray-200 rounded" />
        </div>

        {/* Section stepper placeholder */}
        <div className="flex gap-2 mb-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center gap-2 px-3 py-2 bg-gray-200 rounded-lg">
              <div className="w-5 h-5 rounded-full bg-gray-300" />
              <div className="h-3 w-16 bg-gray-300 rounded" />
            </div>
          ))}
        </div>

        {/* Subsection pills placeholder */}
        <div className="flex gap-2 mb-6">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex items-center gap-2 px-3 py-1.5 bg-gray-200 rounded-full">
              <div className="w-4 h-4 rounded-full bg-gray-300" />
              <div className="h-3 w-12 bg-gray-300 rounded" />
            </div>
          ))}
        </div>

        {/* Form content blocks */}
        <SkeletonFormContent />

        {/* Signature placeholder */}
        <div className="mt-8 bg-white border border-gray-200 rounded-lg p-4">
          <div className="h-4 w-32 bg-gray-200 rounded mb-3" />
          <div className="h-24 w-full bg-gray-100 rounded" />
        </div>

        {/* Navigation buttons placeholder */}
        <div className="mt-8 flex justify-between">
          <div className="h-9 w-28 bg-gray-200 rounded" />
          <div className="h-9 w-28 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export function SkeletonFormContent() {
  return (
    <div className="space-y-5">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="h-4 w-40 bg-gray-200 rounded mb-3" />
          <div className="h-10 w-full bg-gray-100 rounded mb-2" />
          <div className="h-10 w-full bg-gray-100 rounded" />
        </div>
      ))}
    </div>
  )
}
